import axios from 'axios';
import clientConfig from '../client-config';
import setAuthToken from '../utils/setAuthToken';

export async function startBankTransferPayment(paymentData) {
  // Send request
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  if (localStorage.token) {
    let res;
    try {
      res = await axios.post(
        clientConfig.backendHOST + '/invoice/proforma',
        paymentData,
        config
      );
    } catch (e) {
      console.error('error', e);
      return {
        isOk: false,
        error: e,
      };
    }

    if (res) {
      if (res.status === 200) {
        return {
          isOk: true,
          data: res,
        };
      }
    } else {
      return {
        isOk: false,
      };
    }
  } else {
    return {
      isOk: false,
    };
  }
}

export async function getInvoicestatus(paymentData) {
  // Send request
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const requestData = {
    documentId: paymentData.proforma_invoice_id,
    subscriptionRequestId: paymentData.id,
  };

  if (localStorage.token) {
    let res;
    try {
      res = await axios.get(
        clientConfig.backendHOST + '/invoice/',
        {
          params: requestData,
        },

        config
      );
      if (res.status === 200) {
        return {
          isOk: true,
          data: res,
        };
      } else {
        return {
          isOk: false,
        };
      }
    } catch (e) {
      console.error('error', e);
      return {
        isOk: false,
        error: e,
      };
    }
  } else {
    return {
      isOk: false,
    };
  }
}
